<template>
  <div class="format">
    <h2 v-if="currentObject">Formatowanie</h2>
    <template v-if="currentObject">
      <div class="bar">
        <span class="material-symbols-outlined" @click="setAlignElement('left')">
          align_horizontal_left
        </span>
        <span class="material-symbols-outlined" @click="setAlignElement('center')">
          align_horizontal_center
        </span>
        <span class="material-symbols-outlined" @click="setAlignElement('right')">
          align_horizontal_right
        </span>

        <span class="material-symbols-outlined" @click="setAlignElement('top')">
          align_vertical_top
        </span>
        <span class="material-symbols-outlined" @click="setAlignElement('middle')">
          align_vertical_center
        </span>
        <span class="material-symbols-outlined" @click="setAlignElement('bottom')">
          align_vertical_bottom
        </span>
      </div>
      <div v-if="isTextBox" class="bar">
        <div class="group">
          <span class="material-symbols-outlined" :class="{ 'disabled': isBoldDisabled, 'active': isBold }" @click="setBold">
            format_bold
          </span>
          <span class="material-symbols-outlined" :class="{ 'disabled': isItalicDisabled, 'active': isItalic }" @click="setItalic">
            format_italic
          </span>
          <span class="material-symbols-outlined" :class="{ 'active': isUnderline }" @click="setUnderline">
            format_underlined
          </span>
        </div>
        <div class="group">
          <span class="material-symbols-outlined" :class="{ 'active': currentObject.textAlign == 'left' }" @click="setAlign('left')">
            format_align_left
          </span>
          <span class="material-symbols-outlined" :class="{ 'active': currentObject.textAlign == 'center' }" @click="setAlign('center')">
            format_align_center
          </span>
          <span class="material-symbols-outlined" :class="{ 'active': currentObject.textAlign == 'right' }" @click="setAlign('right')">
            format_align_right
          </span>
          <span class="material-symbols-outlined" :class="{ 'active': currentObject.textAlign == 'justify' }" @click="setAlign('justify')">
            format_align_justify
          </span>
        </div>
      </div>
      <el-divider></el-divider>
      <el-row v-if="isTextBox" :gutter="10">
        <el-col :span="4">
          <el-color-picker :value="getColor" @change="setColor" show-alpha></el-color-picker>
        </el-col>
        
        <el-col :span="20">
          <el-tooltip effect="dark" content="Zmiana czcionki jest zablokowana dla tej wersji" placement="bottom" :disabled="!isFontEditorDisabled">
            <el-select :value="getFontFamily" @change="setFontFamily" :filterable="true" placeholder="Czcionka" :disabled="isFontEditorDisabled">
              <el-option
                v-for="font in fonts"
                :key="font.value"
                :label="font.label"
                :value="font.value">
                <img style="margin-top: -3px" height="40" :src="`${assetsPath}/fonts/${font.value}/${font.preview}`" :alt="font.label" />
              </el-option>
            </el-select>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row v-if="isTextBox" type="flex" justify="space-between" :gutter="10">
        <el-col class="row">
          <span class="material-symbols-outlined">
            format_size
          </span>
          <el-input-number @change="setFontSize" :value="getFontSize" :min="1" size="mini" controls-position="right"></el-input-number>
        </el-col>

        <el-col class="row">
          <span class="material-symbols-outlined">
            format_line_spacing
          </span>
          <el-input-number @change="setLineHeight" v-model="currentObject.lineHeight" :precision="2" :step="0.1" :min="0" size="mini" controls-position="right"></el-input-number>
        </el-col>
      </el-row>
      <el-row v-if="isTextBox" >
        <el-col class="row">
          <span class="material-symbols-outlined">
            space_bar
          </span>
          <el-input-number :step="0.1" :precision="2" :value="getCharSpacing" @change="setCharSpacing" size="mini" controls-position="right"></el-input-number>
        </el-col>
      </el-row>
      <el-divider class="hideonmobile" v-if="isTextBox"></el-divider>
      <el-row class="hideonmobile" type="flex" justify="space-between" :gutter="10">
        <el-col class="row">
          <span class="label">X</span>
          <el-input-number @change="setLeft" :step="0.1" :precision="2" v-model="currentObject.left" size="mini" controls-position="right"></el-input-number>
        </el-col>
        <el-col class="row">
          <span class="label">Y</span>
          <el-input-number @change="setTop" :step="0.1" :precision="2" v-model="currentObject.top" size="mini" controls-position="right"></el-input-number>
        </el-col>
      </el-row>
      <el-row class="hideonmobile" type="flex" justify="space-between" :gutter="10">
        <el-col class="row">
          <span class="material-symbols-outlined">
            rotate_right
          </span>
          <el-input-number @change="setAngle" :precision="2" v-model="currentObject.angle" size="mini" controls-position="right"></el-input-number>
        </el-col>
        <el-col class="row">
          <span class="material-symbols-outlined">
            close_fullscreen
          </span>
          <el-input-number @change="setScale" :step="0.1" :precision="2" v-model="currentObject.scaleX" size="mini" controls-position="right"></el-input-number>
        </el-col>
      </el-row>
      <el-divider v-if="showTextStroke"></el-divider>
      <p v-if="showTextStroke" style="font-size: 14px; margin-bottom: 5px;">Obramowanie tekstu</p>
      <el-row v-if="showTextStroke" :gutter="10">
        <el-col :span="4">
          <el-color-picker :value="currentObject.stroke" @change="setStroke" show-alpha size="mini"></el-color-picker>
        </el-col>
        
        <el-col :span="20">
          <el-input-number @change="setStrokeWidth" :min="0" v-model="currentObject.strokeWidth" size="mini"></el-input-number>
        </el-col>
      </el-row>
      <el-divider v-if="showTextStroke" class="hideonmobile"></el-divider>
      <el-row type="flex" justify="space-between" :gutter="0">
        <el-col :span="13">
          <div v-if="loggedIn" class="half">
            Położenie X
            <el-button-group>
              <el-button @click="setAlignElement('left', true)" size="mini">
                <span class="material-symbols-outlined">
                  align_horizontal_left
                </span>
                1/2
              </el-button>
              <el-button @click="setAlignElement('right', true)" size="mini">
                <span class="material-symbols-outlined">
                  align_horizontal_right
                </span>
                1/2
              </el-button>
            </el-button-group>
          </div>
        </el-col>
      </el-row>
    </template>
    <el-divider class="bottom" v-if="currentObject"></el-divider>
    <layers v-if="loggedIn"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Fonts from '../../classes/Fonts';
  import Editor from '../../classes/Editor';
  import App from '../../classes/App';
  import Layers from './Layers.vue'

  export default {
    data() {
      return {
        fonts: [],
        currentObject: null,
        selectionStyles: null
      }
    },
    computed: {
      ...mapGetters('user', [
        'loggedIn',
      ]),
      ...mapGetters('creator', [
        'project',
        'version',
        'activeScene',
      ]),
      assetsPath() {
        return App.assetsPath
      },
      fontConfig() {
        return Fonts.getFontConfig(this.getFontFamily)
      },
      showTextStroke() {
        return this.isTextBox && !this.isFontEditorDisabled
      },
      isBoldDisabled() {
        if (this.isFontEditorDisabled) {
          return true
        }

        if (!this.fontConfig) {
          return true
        }

        return this.isItalic ? !this.fontConfig.boldItalic : !this.fontConfig.bold 
      },
      isItalicDisabled() {
        if (!this.fontConfig) {
          return true
        }

        return this.isBold ? !this.fontConfig.boldItalic : !this.fontConfig.italic
      },
      isFontEditorDisabled() {
        if (this.loggedIn) {
          return false
        }
        
        return this.version.attributes.blockFonts && this.version.attributes.blockFonts === '1'
      },
      isTextBox() {
        return this.currentObject.type == 'textbox'
      },
      isImage() {
        return this.currentObject.type == 'image'
      },
      isBold() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles.every((letter) => letter['fontWeight'] == 'bold')
        }

        return this.currentObject.fontWeight == 'bold'
      },
      isItalic() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles.every((letter) => letter['fontStyle'] == 'italic')
        }

        return this.currentObject.fontStyle == 'italic'
      },
      isUnderline() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles.every((letter) => letter['underline'] == true)
        }

        return this.currentObject.underline == true
      },
      getColor() {
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles[0].fill || this.currentObject.fill
        }

        return this.currentObject.fill
      },
      getFontSize() {
        // If selected text exist then return a fontSize for this selection
        if (this.selectionStyles && this.selectionStyles.length && this.selectionStyles[0].fontSize) {
          return this.selectionStyles[0].fontSize;
        }

        const fontSizes = [];
        const styles = Object.values(this.currentObject.styles);

        if (styles.length) {
          styles.forEach((row) => Object.values(row).forEach((item) => {
            if (item.fontSize || false) {
              fontSizes.push(item.fontSize)
            }
          }));
        }

        const uniqueFontSize = [...new Set(fontSizes)];

        // Every letter of text has the same fontSize then return that font size
        if (fontSizes.length === this.currentObject.text.length && uniqueFontSize.length === 1) {
          return uniqueFontSize[0];
        }

        // If the text has more the one unique fontSize or
        // we found only one unique fontSize and is different then fontSize from box
        // then we return maximum
        if (uniqueFontSize.length > 1 || (uniqueFontSize.length === 1 && uniqueFontSize[0] != this.currentObject.fontSize)) {
          uniqueFontSize.push(this.currentObject.fontSize);
          return Math.max(...uniqueFontSize);
        }

        // Return the font from box
        return this.currentObject.fontSize;
      },
      getFontFamily() {
        // If selected text exist then return a fontFamily for this selection
        if (this.selectionStyles && this.selectionStyles.length) {
          return this.selectionStyles[0].fontFamily || this.currentObject.fontFamily;
        }

        const fontNames = [];
        const styles = Object.values(this.currentObject.styles);

        if (styles.length) {
          styles.forEach((row) => Object.values(row).forEach((item) => {
            if (item.fontFamily || false) {
              fontNames.push(item.fontFamily)
            }
          }));
        }

        const uniqueFontName = [...new Set(fontNames)];

        // Every letter of text has the same fontFamily then return that font name
        if (fontNames.length === this.currentObject.text.length && uniqueFontName.length === 1) {
          return uniqueFontName[0];
        }

        // If the text has more the one unique fontFamily or
        // we found only one unique font and is different then font from box
        // then we don't know font name
        if (uniqueFontName.length > 1 || (uniqueFontName.length === 1 && uniqueFontName[0] != this.currentObject.fontFamily)) {
          return '';
        }

        // Return the font from box
        return this.currentObject.fontFamily;
      },
      getCharSpacing() {
        console.log('get getCharSpacing');
        if (this.selectionStyles && this.selectionStyles.length) {
          console.log('selection getCharSpacing');
          return this.selectionStyles[0].charSpacing || this.currentObject.charSpacing
        }

          console.log('global getCharSpacing');
        return this.currentObject.charSpacing
      }
    },
    async mounted() {

      Editor.addCallback('selection:created', () => {
        this.currentObject = Editor.canvas.getActiveObject()
      })
      
      Editor.addCallback('selection:updated', () => {
        this.currentObject = Editor.canvas.getActiveObject()
      })   

      Editor.addCallback('selection:cleared', () => {
        this.currentObject = null
        this.selectionStyles = []
        console.log('right selection cleared')
      })

      Editor.addCallback('text:selection:changed', () => {
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles()
        console.log('right text:selection:changed')
      })

      this.fonts = await Fonts.getAvailable()
    },
    methods: {
      printInfromation() {
        const showPrintInfromation = !localStorage.printInfromation;
        if (showPrintInfromation) {
          this.$alert('Zmieniając kolor należy mieć na uwadze, że ostateczny kolor może się nieznacznie różnić od wybranego, ponieważ zależy to od rodzaju i ustawień monitora.', 'Uwaga!', {
            confirmButtonText: 'OK',
            type: 'warning',
          });

          localStorage.printInfromation = true;
        }
      },
      setBold() {
        Editor.setStyleForActiveObject('fontWeight', 'bold');
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setItalic() {
        Editor.setStyleForActiveObject('fontStyle', 'italic');
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setUnderline() {
        Editor.setStyleForActiveObject('underline', true);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setAlign(direction) {
        Editor.setStyleForActiveObject('textAlign', direction, false, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setAlignElement(direction, onHalf) {
        let realObjectWidth = this.currentObject.width / this.currentObject.scaleX
        let realObjectHeight = this.currentObject.height / this.currentObject.scaleY

        let left = 0
        let right = Editor.width - realObjectWidth

        const marginSize = Editor.parseToPixel(Editor.project.version.margin + 'mm') * Editor.zoom.scale

        if (onHalf) {
          left = (((Editor.width / 2) - realObjectWidth) / 2) + (marginSize / 2)
          right -= left
        } else {
          left += marginSize
          right -= marginSize
        }

        switch (direction) {
          case 'right':
            Editor.setStyleForActiveObject('left', right, false, false);
            break;
          case 'center':
            Editor.setStyleForActiveObject('left', (Editor.width - realObjectWidth) / 2, false, false);
            break;
          case 'left':
            Editor.setStyleForActiveObject('left', left, false, false);
            break;
          case 'top':
            Editor.setStyleForActiveObject('top', marginSize, false, false);
            break;
          case 'middle':
            Editor.setStyleForActiveObject('top', (Editor.height - realObjectHeight) / 2, false, false);
            break;
          case 'bottom':
            Editor.setStyleForActiveObject('top', Editor.height - realObjectHeight - marginSize, false, false);
            break;
        }
      },
      setFontSize(fontSize) {
        Editor.setStyleForActiveObject('fontSize', fontSize, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      incFontSize() {
        this.currentObject.fontSize = this.currentObject.fontSize + 1
        Editor.setStyleForActiveObject('fontSize', this.currentObject.fontSize, false);
      },
      decFontSize() {
        this.currentObject.fontSize = this.currentObject.fontSize - 1
        Editor.setStyleForActiveObject('fontSize', this.currentObject.fontSize, false);
      },
      setLineHeight() {
        Editor.setStyleForActiveObject('lineHeight', this.currentObject.lineHeight, false);
      },
      setStrokeWidth() {
        Editor.setStyleForActiveObject('strokeWidth', this.currentObject.strokeWidth, false);
      },
      setLeft() {
        Editor.setStyleForActiveObject('left', this.currentObject.left, false, false);
      },
      setTop() {
        Editor.setStyleForActiveObject('top', this.currentObject.top, false, false);
      },
      setAngle() {
        Editor.setStyleForActiveObject('angle', this.currentObject.angle, false, false);
      },
      setScale(scale) {
        Editor.setStyleForActiveObject('scaleX', scale, false, false);
        Editor.setStyleForActiveObject('scaleY', scale, false, false);
      },
      setColor(color) {
        this.printInfromation();
        Editor.setStyleForActiveObject('fill', color, false);
      },
      setStroke(color) {
        this.printInfromation();
        Editor.setStyleForActiveObject('stroke', color, false);
      },
      setCharSpacing(charSpacing) {
        Editor.setStyleForActiveObject('charSpacing', charSpacing, false, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();
      },
      setFontFamily(fontFamily) {
        this.loadAndUse(fontFamily);
      },
      async loadAndUse(font) {

        await Fonts.load(font)

        Editor.setStyleForActiveObject('fontFamily', font, false);
        this.selectionStyles = Editor.canvas.getActiveObject().getSelectionStyles();

        if (this.isBold && !this.fontConfig.bold) {
          this.setBold()
        }

        if (this.isItalic && !this.fontConfig.italic) {
          this.setItalic()
        }

        if (this.isItalic && this.isBold && !this.fontConfig.boldItalic) {
          this.setItalic()
        }
      }
    },
    components: {
      Layers
    }
  }
</script>

<style lang="less" scoped>
  .right {
    .el-divider {
      background-color: #eee;
      margin: 15px 0;
    }
    .el-select,
    .el-input-number,
    .el-color-picker,
    .el-button-group {
      margin-top: 8px;
    }
    .el-col,
    .el-row {
      font-size: 14px;
    }
    .el-row + .el-row {
      margin-top: 15px;
    }
  }
  .hideonmobile {
    @media (max-width: 767px) {
      display: none;
    }
  }

  .el-divider.bottom {
    margin-top: 25px;
  }

  .bar {
    background: #f4f6fc;
    padding: 8px 16px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;

    span {
      color: #707174;
      color: ;
      font-size: 18px;
      padding: 5px;
      background: transparent;
      transition: .3s color, background;

      &.disabled {
        color: #bbbfcf;
        pointer-events: none;
      }

      &:hover,
      &.active {
        cursor: pointer;
        background: #fff;
        color: #000;
        border-radius: 5px;
        transition: .3s color, background;
        box-shadow: 0 0 10px 2px rgba(0, 0, 0, .05);
      }

      + span {
        margin-left: 5px;
      }
    }
    + .bar {
      margin-top: 16px;
    }
  }

  .el-col.row {
    display: flex;
    align-items: center;

    .el-input-number {
      margin-top: 0;
      margin-left: 16px;
    }

    .label {
      font-weight: 600;
      font-size: 20px;
      width: 24px;
      text-align: center;
    }
  }

  .el-input-number.is-controls-right {
    max-width: 80px;
    width: 80px;
  }

  h2 {
    margin-top: 0;
  }

  .half {
    /deep/ .el-button > span {
      display: flex;
      align-items: center;
    }
    .material-symbols-outlined {
      font-size: 18px;
      margin-right: 5px;
    }
  }
</style>